import { CalendarPlanShowcaseConfigTeaser } from '@yandex-int/k-common/typings';
import React from 'react';

import { SimpleCallback } from '../../typings';

import { ShowcaseLessonTeaserCardButton } from './__button/showcase-lesson-teaser-card__button';
import { ShowcaseLessonTeaserCardContent } from './__content/showcase-lesson-teaser-card__content';
import { ShowcaseLessonTeaserCardDates } from './__dates/showcase-lesson-teaser-card__dates';
import { ShowcaseLessonTeaserCardDescription } from './__description/showcase-lesson-teaser-card__description';
import { ShowcaseLessonTeaserCardPreview } from './__preview/showcase-lesson-teaser-card__preview';
import { ShowcaseLessonTeaserCardTitle } from './__title/showcase-lesson-teaser-card__title';

import './showcase-lesson-teaser-card.scss';

export interface ShowcaseLessonTeaser {
    from: Date;
    id: number;
    to: Date;
}

interface Props {
    onOpenPlanButtonClick?: SimpleCallback;
    onUploadPlanButtonClick?: SimpleCallback;
    teaser: ShowcaseLessonTeaser;
    teaserConfig: CalendarPlanShowcaseConfigTeaser;
}

export const ShowcaseLessonTeaserCard = ({
    onOpenPlanButtonClick,
    onUploadPlanButtonClick,
    teaser: { from, to },
    teaserConfig: { backgroundColor, description, image, openCalendarButtonText, title, uploadCalendarButtonText },
}: Props) => (
    <div className="showcase-lesson-teaser-card" style={{ backgroundColor }}>
        <ShowcaseLessonTeaserCardPreview image={image}>
            <ShowcaseLessonTeaserCardDates from={from} to={to} />
        </ShowcaseLessonTeaserCardPreview>
        <ShowcaseLessonTeaserCardContent>
            <ShowcaseLessonTeaserCardTitle text={title} />
            <ShowcaseLessonTeaserCardDescription text={description} />
            <div>
                <ShowcaseLessonTeaserCardButton onClick={onOpenPlanButtonClick} text={openCalendarButtonText} />
                <ShowcaseLessonTeaserCardButton onClick={onUploadPlanButtonClick} text={uploadCalendarButtonText} />
            </div>
        </ShowcaseLessonTeaserCardContent>
    </div>
);
